import SwitchToTraqqText from '@components/Ads/SwitchToTraqqWideText/SwitchToTraqqText'
import { Bg } from './bg'
import css from '@utils/css'
import React from 'react'

const SwitchToTraqqDiscount = () => {
    return (
        <>
            <div className={ css(
                'relative hidden 768:block'
            ) }>
                <Bg className={ css(
                    'absolute -z-10 -bottom-72p',
                    'w-798p h-704',
                    '768:(-right-420p)',
                    '1024:(w-905p h-798p -right-425p)',
                    '1280:(-right-380p)'
                ) }/>
                <div className={ css(
                    '!text-white font-[900] text-center',
                    '768:(text-130p leading-108p)',
                    '1024:(text-154p leading-140p)'
                ) }>
                    30%
                    <br/>
                    OFF
                </div>
            </div>
            <div className='768:hidden'>
                <SwitchToTraqqText/>
            </div>
        </>
    )
}

export default SwitchToTraqqDiscount
